/**
 * 登录页分流（不依赖 @/store，避免 api ↔ store ↔ loginRedirect 循环依赖）
 */

import { appFullPath } from '@/utils/appPublicPath'

function normalizedPathname() {
  const raw = (typeof window !== 'undefined' && window.location && window.location.pathname) || ''
  const base = (process.env.BASE_URL || '/').replace(/\/$/, '')
  if (base && (raw === base || raw.startsWith(base + '/'))) {
    return raw.slice(base.length) || '/'
  }
  return raw
}

function readOnlyActivityDashboardFromStorage() {
  try {
    const stored = localStorage.getItem('userInfo')
    if (!stored) {
      return false
    }
    const u = JSON.parse(stored)
    return !!(u && u.onlyActivityDashboard === true)
  } catch (e) {
    return false
  }
}

/**
 * Token 失效等场景跳转的登录页路径：
 * - 当前在大屏相关路径，或本地曾标记为大屏专用账号 → 大屏登录页
 * - 否则 → 业务登录页 /login（勿与大屏登录混用）
 */
export function getLoginPathForSessionExpiry() {
  try {
    const p = normalizedPathname()
    if (p.includes('activity-dashboard')) {
      return appFullPath('/activity-dashboard-login')
    }
    if (readOnlyActivityDashboardFromStorage()) {
      return appFullPath('/activity-dashboard-login')
    }
  } catch (e) {
    /* ignore */
  }
  return appFullPath('/login')
}

/**
 * 大屏登录成功后的跳转：只允许回大屏页，避免 ?redirect= 指到 /login、/home 等业务路由
 */
export function resolveActivityDashboardPostLoginRedirect(queryRedirect) {
  const raw = typeof queryRedirect === 'string' ? queryRedirect.trim() : ''
  if (!raw.startsWith('/')) {
    return '/activity-dashboard'
  }
  const pathPart = raw.split('?')[0]
  if (pathPart === '/activity-dashboard') {
    return raw
  }
  return '/activity-dashboard'
}
